"use strict";


import $ from 'jquery';


(function() {

	accordionConfig();

})();


function accordionConfig() {

	var els = document.querySelectorAll('[ui-accordion-trg]');

	for (let i = 0; i < els.length; i++) {
		const el = els[i];
		el.addEventListener('click', accordionOnClick);
	}

}


function accordionOnClick(e) {

	const el = e.target,
		wrapEl = $(el).parents('[ui-accordion]')[0],
		contentEl = wrapEl.querySelector('[ui-accordion-content]');

	if (contentEl.offsetParent === null) {
		wrapEl.classList.add('is-showing');
		$('.carsl', $(contentEl)).slick('setPosition');
	} else {
		wrapEl.classList.remove('is-showing');
	}

	// $(contentEl).slideToggle(800, function() {
	// 	if (contentEl.offsetParent !== null) {
	// 		$('.carsl', $(contentEl)).slick('setPosition');
	// 	}
	// });
	$(contentEl).slideToggle(800);

}



// WEBPACK FOOTER //
// ./js/accordion.js